import { asMultiStyleConfig } from '../../../../utils/theme';
import { transparentize } from '../../../../utils/color';
export var SuccessBanner = asMultiStyleConfig({
  parts: ['alert', 'body', 'successIcon', 'title', 'subtitle', 'message', 'warningBody', 'warning', 'warningIcon', 'externalLink', 'contentBody'],
  baseStyle: {
    alert: {
      w: '100%',
      pt: [6, 8],
      pb: [6, '2.625rem'],
      px: [6, 8],
      borderRadius: 'lg',
      backgroundColor: 'green.1000',
      border: '2px solid #34AA40',
      overflow: 'hidden'
    },
    body: {
      mx: 'auto',
      textAlign: 'center',
      borderColor: 'none'
    },
    successIcon: {
      height: ['2rem', '4rem'],
      width: ['2rem', '4rem'],
      color: '#34AA40',
      mx: 'auto'
    },
    title: {
      fontSize: ['lg', 'xl'],
      lineHeight: ['base', 'tall'],
      fontWeight: 'bold',
      mt: ['1rem !important', '1.25rem !important']
    },
    subtitle: {
      fontSize: ['md', 'lg'],
      fontWeight: 'bold'
    },
    message: {
      fontSize: ['sm', 'md'],
      lineHeight: ['short', 'base']
    },
    warningBody: {
      display: 'flex',
      p: [4, 6],
      mb: [-6, '-2.625rem'],
      mx: [-6, -8],
      mt: [4, 6],
      bg: transparentize('green.500', 0.2)
    },
    warning: {
      fontSize: ['sm', 'md'],
      lineHeight: ['short', 'base'],
      mx: 'auto',
      fontWeight: 600
    },
    warningIcon: {
      mr: 3,
      w: 5,
      h: 5,
      flexShrink: 0,
      color: 'orange.700'
    },
    externalLink: {
      color: 'blue.600'
    },
    contentBody: {
      p: 6,
      mb: [-6, -8],
      mx: [-6, -8],
      mt: 6
    }
  }
});